import { ActionTypes } from '../types/actionTypes';
import { TAdvancedSearch } from '../types/actions';
import { IAdvancedSearch } from '../../types/interfaces';

const initialState = {
  tags: '',
  okpd2_codes: [],
  okpd2_expansion_level: 0,
  regions: [],
  regions_expansion_radius: 0,
  exclude_root_region: 1,
  is_supplier: 'yes',
  is_msp: 1,
  exclude_dishonest: 1,
  limit: 50,
  bids_regions: [],
  bids_regions_expansion_radius: 0,
  bids_regions_exclude_root: 1,
  regions_by_inn: [],
  linked_buyer_description: '',
  relevance: {
    procedure_bids_count_total: 100,
    procedure_bids_count_won_total: 0,
    average_procedure_bids_nmc: null,
    latest_procedure_bid_date: null,
    okpd2_procedure_bids_count: null,
    okpd2_won_procedure_bids_count: null,
    region_and_okpd2_procedure_bids_count: null,
    tags_procedure_bids_count: null,
    procedure_bids_count_for_buyer: 0,
    bids_region_procedure_bids_count: 0,

  },
} as IAdvancedSearch;

export default function advancedSearch(state: IAdvancedSearch = initialState, action: TAdvancedSearch) {
  switch (action.type) {
    case ActionTypes.SET_ADVANCED_SEARCH_VALUE:
      return { ...state, tags: action.payload };
    case ActionTypes.SET_OKPD2:
      return { ...state, okpd2_codes: [...action.payload] };
    case ActionTypes.SET_REGION:
      return { ...state, regions: [...action.payload] };
    case ActionTypes.SET_RADIUS:
      return { ...state, regions_expansion_radius: action.payload };
    case ActionTypes.SET_MSP:
      return { ...state, is_msp: action.payload };
    case ActionTypes.SET_RPN:
      return {
        ...state,
        exclude_dishonest: action.payload,
      };
    case ActionTypes.SET_LIMIT:
      return { ...state, limit: action.payload };
    case ActionTypes.SET_SORT_PARTICIPATION:
      return {
        ...state,
        relevance: {
          ...state.relevance,
          procedure_bids_count_won_total: 0,
          procedure_bids_count_total: action.payload,
        },
      };

    case ActionTypes.SET_SORT_VICTORIES:
      return {
        ...state,
        relevance: {
          ...state.relevance,
          procedure_bids_count_total: 0,
          procedure_bids_count_won_total: action.payload,
        },
      };
    case ActionTypes.CLEAR:
      return { ...initialState };
    case ActionTypes.SET_PROCEDURE_BIDS_COUNT_FOR_BUYER:
      return {
        ...state,
        relevance: {
          ...state.relevance,
          procedure_bids_count_for_buyer: action.payload,
        },
      };
    case ActionTypes.SET_BIDS_REGION_PROCEDURE_BIDS_COUNT:
      return {
        ...state,
        relevance: {
          ...state.relevance,
          bids_region_procedure_bids_count: action.payload,
        },
      };
    case ActionTypes.SET_TAGS_PROCEDURE_BIDS_COUNT:
      return {
        ...state,
        relevance: {
          ...state.relevance,
          tags_procedure_bids_count: action.payload,
        },
      };
    case ActionTypes.SET_OKPD2_WON_PROCEDURE_BIDS_COUNT:
      return {
        ...state,
        relevance: {
          ...state.relevance,
          okpd2_won_procedure_bids_count: action.payload,
        },
      };
    case ActionTypes.SET_LINKED_BUYER_DESCRIPTION:
      return {
        ...state,
        linked_buyer_description: action.payload,
      };
    case ActionTypes.SET_REGIONS_BY_INN:
      return { ...state, regions_by_inn: [...action.payload] };
    case ActionTypes.SET_BIDS_REGIONS:
      return { ...state, bids_regions: [...action.payload] };
    default:
      return state;
  }
}
